import React, {
    PureComponent
  }                             from 'react';
import PropTypes              from 'prop-types';
import { AnimatedView  }        from '../../../../components';
import WebcamCapture from '../../../../components/reactCamera/reactCamera.js';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';
import device           from "current-device";


const is_mobile = device.mobile();

var count_of_drop_down = 0;
var count_of_section = 0;
function deepcopy(o) {
   var output, v, key;
   output = Array.isArray(o) ? [] : {};
   for (key in o) {
       v = o[key];
       output[key] = (typeof v === "object" && v instanceof File == false) ? deepcopy(v) : v;
   }
   return output;
}

class Checkin extends PureComponent{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            venues: [],
            openCamera:false,
            current_image_src:'',
            current_image_id:'',
            image_list:[],
            check_list: {"items":[]},
            response_list: [],
            check_list_type_zero:[],
            check_list_type_one:[{
                name:is_mobile?"....select....":"...... select ...... ",
            }],
            venue:'',
            text: 0,
            add_item:{
                  
            },
            responses:[],
            selected_item:[
                {
                  
                  id:'',
               
                  index: 0,
                  value: null,
                
              }
            ],
            
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.postResponse = this.postResponse.bind(this);
        this.handleChecklist = this.handleChecklist.bind(this);
        this.handletask = this.handletask.bind(this);
        this.receivePicture = this.receivePicture.bind(this);
        this.b64toBlob = this.b64toBlob.bind(this);

    }


    

    componentDidMount() {
        this.getChecklist()
        
    }




    getChecklist() {
        const url = `${getLocationOrigin()}/cm/get_desk_manager_checkin_list/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            { 
              venues: data.venues,
              check_list: data.check_list,
              venue:data.venues[0].id
            });
            this.handleChecklist();
            this.handletask();
           })
          .catch(error => error);
    }

    postResponse(event) {
        event.preventDefault();
        var null_count = 0
        var final_response = Object.assign([],this.state.response_list)
        for (var i = 0;i<final_response.length;i++){
            if(final_response[i].response == 'null'){
                null_count ++;
            }
        }
        if(null_count == 0){
        const url = `${getLocationOrigin()}/cm/save_tasks_for_checklist/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        var formData = new FormData();
        formData.append('response_list', JSON.stringify(this.state.response_list))
        formData.append('venue', this.state.venue)
        formData.append('check_type', "Checkin")
        formData.append('short_code', "desk_manager_check_in")
        var image_ids = []
        for (var i = this.state.image_list.length - 1; i >= 0; i--) {
          var img = this.state.image_list[i]
          formData.append("image_" + img['id'],this.b64toBlob(img['picture'],'image/jpeg' ))                                                                        
          image_ids.push(img['id'])
        };
        formData.append('image_ids',JSON.stringify(image_ids))                                  
        
        options['body'] = formData

        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then((response) => {                      // first then()
              alert("Successfully checked in with details tasks")
              console.log('response',response)
              this.props.history.goBack();
              location.reload();

                   })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }
          else{
            alert('Please check all tasks')
          }

    
    }


  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
      
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }    

    addSection(event){
       console.log(this.state.selected_item[0].value)
      var last_elem = this.state.selected_item[this.state.selected_item.length -1]
      console.log(last_elem);
      if (last_elem.sessionSectionTitle != ""){
          var sections = deepcopy(this.state.selected_item);
          var add_new = {};
          add_new.index = count_of_section + 1;
          count_of_section = count_of_section +1;
          add_new.value = null;

          sections.push(add_new);
          if(count_of_drop_down  < this.state.check_list_type_one.length + 1 ){
                        this.setState({
                          selected_item: sections
                      });
                      count_of_drop_down ++ ;
                      
                      console.log("added section");
                      console.log(sections);
            }
      }
    }


    handletask(){
        
        var new_checklist = Object.assign([], this.state.check_list.items);
        var type_zero = Object.assign([], this.state.check_list_type_zero);
        var type_one = Object.assign([], this.state.check_list_type_one);
        for(var i = 0; i <= new_checklist.length ; i++){
            var temp_obj = {};
             temp_obj = new_checklist[i];
            if (temp_obj.task_type == 1)
            {   
                type_one.push(temp_obj);
                console.log("type_one")
            }
            else if(temp_obj.task_type == 0){
                type_zero.push(temp_obj);
                console.log("type_zero")
            }
        }
        this.setState({check_list_type_zero:type_zero,check_list_type_one:type_one})


    }
    


    handleChange(event,index) {
        const name = event.target;
        var temp_item ={};
        var old_value = 0;
        var temp_list = this.state.response_list;
        var selected_item_variable = this.state.selected_item;
        if(name.name=='venue'){
            this.setState({venue:name.value});
        }
        else if (name.name == 'items'){
            temp_item.id = event.target.value;
            temp_item.index = index
            if(this.state.add_item.index == index){
                for ( var i = 0; i < temp_list.length; i++){    
                    if(temp_list[i]){
                    var temp = temp_list[i];
                    if(temp.items==this.state.add_item.id)
                    {   
                        old_value = temp_list[i].response;
                        temp_list[i].response = 'null';
                        this.setState({response_list:temp_list});
                    }  
                    
                }}
            }

            for ( var i =0;i<this.state.selected_item.length;i++){
                
                if(index == selected_item_variable[i].index){
                    selected_item_variable[i].id = event.target.value;

                    this.setState({selected_item:selected_item_variable})
                }
            }
            for ( var i = 0; i < temp_list.length; i++){    
                    if(temp_list[i]){
                    var temp = temp_list[i];
                    if(temp.items == event.target.value){
                                temp_list[i].response = old_value;

                                this.setState({response_list:temp_list});

                            }
            }}
            temp_item.value = old_value;
            this.setState({add_item:temp_item});
        }

    }

    handletextcount(event,item,index){
        var new_checklist = Object.assign([], this.state.response_list);
        for (var i=0;i<new_checklist.length;i++){
            if(new_checklist[i].items ==item ){
                new_checklist[i].response = event.target.value
                break;
            }
        }
        this.setState({response_list:new_checklist})
        console.log(this.state.response_list)

    }


    handleChecklist(){
        var checklist_items = Object.assign([], this.state.check_list);
        var new_value =  {};
        var old_obj = this.state.check_list.items;
        var response_list = Object.assign([], this.state.response_list);


        for (var i=0;i<old_obj.length;i++){
            if(old_obj[i].task_type == 0){
                new_value =  {};
                new_value.items = old_obj[i].id;
                new_value.response = "null";
                new_value.picture = '';
                response_list.push(new_value);
            }
            // else if(old_obj[i].task_type == 1){
            //     new_value =  {};
            //     new_value.items = old_obj[i].id;
            //     new_value.response = 0;
            //     response_list.push(new_value);
            // }
            this.setState({response_list:response_list})
        }

        
        
    }

    
    handleRadio = (e, s) => {
        var old_obj = this.state.response_list;
        var index,a = 0;
        for ( var i = 0; i <= old_obj.length; i++){    
            if(old_obj[i]) {
                var temp = old_obj[i];
                if(temp.items==s){
                    a++;
                    index = i;
                }  
            }  
        }
            var new_value =  {};
            new_value.items = s;
            new_value.response = e.target.value;
                     
            if(a == 0)  { this.state.response_list.push(new_value);  
              console.log(old_obj)}
            else{
                var temp = old_obj[index];
                old_obj.splice(index,1);
                old_obj.push(new_value);
                console.log(old_obj)
                this.setState({response_list:old_obj});
            }
    }
    receivePicture(imageSrc){
      console.log(imageSrc)
      var image_adding_count = 0 ;
      var task_respose = Object.assign([], this.state.image_list);
      for(var t= 0;t<task_respose.length;t++){
        if(task_respose[t].id == this.state.current_image_id){
          task_respose[t].picture = imageSrc;
          image_adding_count ++;
        }
      }
      if(image_adding_count==0){
        this.state.image_list.push({'id':this.state.current_image_id,'picture':imageSrc})
      }else{
        this.setState({image_list:task_respose,})        
      }
      this.setState({current_image_src:imageSrc,openCamera:false}) 
      console.log(this.state)
    }

    openCamera(task_id){
      if(task_id == this.state.current_image_id){
        this.setState({openCamera:!this.state.openCamera});
      }
      else {
      this.setState({openCamera:true,current_image_id:task_id});
      }
    }

    handleSubmit(event){
        event.preventDefault();
        this.postResponse(event);
        console.log('post');
        console.log(this.state.response_list);
        console.log(this.state);
    }

    render(){
      console.log(this.state)
        let general_count=1;
        let covid_count=1;

        return(
        <div style={styles.container} style={styles.container}>
            <div className="row col-md-8 table-bordered" style={styles.table}>
                <div style={styles.main_header} >
                    Check In
                </div>
                
                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
                        <div style={styles.items}  className="col-md-12">
                            <div className="col-md-12" style={{display:'flex',flexDirection:'row'}} >
                                <div style={styles.item_header}  className="col-md-6">
                                    Venue
                                </div>
                                
                                <div className="col-md-6" >
                                    <select name="venue"    value={this.state.venue}
                                        onChange={this.handleChange}>
                                        {
                                        this.state.venues.map((venue, index) => (
                                        <option key={venue.id} value={venue.id}>{venue.name}</option>
                                        ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-12" style={{color:'red',textAlign:'left',marginLeft:'10%',paddingTop:'1%'}} > * Please fill out all the fields with relevant images. <br/> * Select NA if facility is not available.  </div>                                
                            <div style={styles.check_list}  className="col-md-12">
                                {
                                this.state.check_list.items.map((check_list_item, index) => (check_list_item.task_type == 0 && !check_list_item.is_covid_task &&
                                    <div >
                                        
                                        <div style={{display:'flex',flexDirection:'row'}} >
                                            <div>{general_count++}.</div>
                                            <div className="col-md-6" style={styles.check_list_task} >
                                                <div key={index.id} value={index}>{check_list_item.name}</div>     
                                            </div>
                                            
                                            <div className="col-md-6" style={{display:'flex',flexDirection:'row'}}>
                                                
                                                <div style={styles.radio_button} className='col-md-2'>
                                                <input type="radio" 
                                                    value="YES" name= {check_list_item.name}
                                                    onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                  />
                                                YES
                                               </div>
                                               <div style={styles.radio_button} className='col-md-2'>
                                                <input type="radio" 
                                                    value="NO" name= {check_list_item.name}
                                                    onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                  />
                                                NO
                                               </div>
                                               <div style={styles.radio_button} className='col-md-2'>
                                                <input type="radio" 
                                                    value="NA" name= {check_list_item.name}
                                                    onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                  />
                                                NA
                                               </div>
                                               <i className="far fa fa-camera" style={{fontSize:'150%',marginLeft:'5%',marginTop:'1%'}} onClick={(e)=>this.openCamera(check_list_item.id)} > </i>
                                            </div>
                                          </div>

                                          {this.state.image_list.map((image,index)=>(
                                                <div className="image_container" style={{textAlign:'center',margin:5}} >{image.id == check_list_item.id &&
                                                      <img id={image.id} style={{marginTop:'1%'}} src={image.picture} alt="Image 1" /> 
                                                    }
                                                </div>))
                                          }
                                          {this.state.openCamera && check_list_item.id == this.state.current_image_id &&
                                          <div style={{textAlign:'center'}}>
                                              <WebcamCapture  callback={this.receivePicture}/>
                                          </div>
                                          }
                                    </div>
                                ))
                                }                            
                            </div>

                            <div style={styles.check_list}  >
                                {/*
                                this.state.check_list.items.map((check_list_item, index) => (check_list_item.task_type == 1 &&
                                    <div className="col-md-12" style={{display:'flex',flexDirection:'row'}}>
                                        <br/>
                                        <div className="col-md-6" style={styles.check_list_task} >
                                            <div key={index.id}  value={index}>{check_list_item.name}</div>  
                                        </div>
                                        <div className="col-md-6" style={{display:'flex',flexDirection:'row',marginTop:'2px',paddingLeft:'7%'}}>
                                            <input  type="text" id = {check_list_item.id}  name = {check_list_item.id} placeholder={check_list_item.name} value={this.state.value}                                                   
                                                                        onChange={(e) => this.handletextcount(e,check_list_item.id,index)}
                                                                    />
                                        </div>    
                                    </div>
                                ))
                                */}                            
                            </div>
                            <div className="col-md-12" style={{color:'red',textAlign:'left',marginLeft:'10%',paddingTop:'1%'}} >COVID Guidelines</div>
                            <div style={styles.check_list}  className="col-md-12">
                                {
                                this.state.check_list.items.filter(data=> data.is_covid_task).map((check_list_item, index) => (check_list_item.task_type == 0 &&
                                    <div >
                                        
                                        <div style={{display:'flex',flexDirection:'row'}} >
                                            <div>{covid_count++}.</div>
                                            <div className="col-md-6" style={styles.check_list_task} >
                                                <div key={index.id} value={index}>{check_list_item.name}</div>     
                                            </div>
                                            
                                            <div className="col-md-6" style={{display:'flex',flexDirection:'row'}}>
                                                
                                                <div style={styles.radio_button} className='col-md-2'>
                                                <input type="radio" 
                                                    value="YES" name= {check_list_item.name}
                                                    onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                  />
                                                YES
                                               </div>
                                               <div style={styles.radio_button} className='col-md-2'>
                                                <input type="radio" 
                                                    value="NO" name= {check_list_item.name}
                                                    onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                  />
                                                NO
                                               </div>
                                               <div style={styles.radio_button} className='col-md-2'>
                                                <input type="radio" 
                                                    value="NA" name= {check_list_item.name}
                                                    onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                  />
                                                NA
                                               </div>
                                               <i className="far fa fa-camera" style={{fontSize:'150%',marginLeft:'5%',marginTop:'1%'}} onClick={(e)=>this.openCamera(check_list_item.id)} > </i>
                                            </div>
                                          </div>

                                          {this.state.image_list.map((image,index)=>(
                                                <div className="image_container" style={{textAlign:'center',margin:5}} >{image.id == check_list_item.id &&
                                                      <img id={image.id} style={{marginTop:'1%'}} src={image.picture} alt="Image 1" /> 
                                                    }
                                                </div>))
                                          }
                                          {this.state.openCamera && check_list_item.id == this.state.current_image_id &&
                                          <div style={{textAlign:'center'}}>
                                              <WebcamCapture  callback={this.receivePicture}/>
                                          </div>
                                          }
                                    </div>
                                ))
                                }                            
                            </div>
                            
                           
                            

                        </div>


                        <div style={styles.button_submit} className="col-md-12">
                            <input className="button1" type="submit" value="Check In" />
                        </div>
                
                </form>
            </div>
        </div>    
        );
    }
}

export default Checkin;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/checkin/index.js